export default [
    {
        path: '/lol',
        component: () => import('./index.vue'),
    },
]